import { Button } from "@/common/components/button";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  getHeadOfHospitalInventoryTableData,
  headOfHospitalInventoryTableHeaders,
  headOfHospitalInventoryTableKeys,
  inventoryStatisticCards,
  linechartData,
  lineChartOptions,
} from "../data";
import { InventoryWrapper } from "../style";
import notificationIcon from "@/assets/images/Notification.png";
import { LineChart } from "../../common/LineChart";
import Table from "@/common/components/Table";
import useQuery from "@/hooks/useQuery";
import {
  INVENTORY_SALES_STATS_URL,
  INVENTORY_STATS_COUNT_URL,
  INVENTORY_TRANSACTION_URL,
} from "@/common/constants";
import { useNavigate } from "react-router-dom";

const PharmacyHeadInventory = () => {
  const navigate = useNavigate();
  const { data: recent_orders, loading: headOfHospitalInventoryStatLoading } =
    useQuery(INVENTORY_TRANSACTION_URL);
  const { data: stat_count } = useQuery(INVENTORY_STATS_COUNT_URL);
  const { data: sales_statistics } = useQuery(INVENTORY_SALES_STATS_URL);
  const handleNavigation = (route: string) => {
    navigate(`/dashboard/pharmacy-head/inventory/${route}`);
  };
  return (
    <InventoryWrapper>
      <div className="card-wrapper">
        {inventoryStatisticCards(stat_count)?.map(
          (card: any, index: number) => (
            <LargeCard
              key={index}
              color={card?.color}
              icon={card?.icon}
              value={card?.value}
              title={card?.name}
            />
          )
        )}
      </div>
      <div className="">
        <div className="cta-stock">
          <div className="cta-wrapper">
            <div>
              <h1>ALL DRUG INVENTORY</h1>
              <p>Manage your pharmaceutical inventory</p>
            </div>
            <Button onClick={() => handleNavigation("all-drugs")}>View</Button>
          </div>
          <div className="cta-wrapper">
            <div>
              <h1>
                NOTIFICATION
                <img src={notificationIcon} alt="notification" />
              </h1>
              <p>
                Monitor and manage inventory alerts for proactive stock
                management
              </p>
            </div>
            <Button onClick={() => handleNavigation("notifications")}>
              View
            </Button>
          </div>
        </div>
      </div>

      <div className="chart-wrapper">
        <LineChart
          first="Stock in"
          second="Stock out"
          title="Stock Movement Trend"
          chartData={linechartData(sales_statistics)}
          options={lineChartOptions}
          height={400}
        />
      </div>

      <div className="table-wrapper">
        <Table
          tableHeaders={headOfHospitalInventoryTableHeaders}
          tableKeys={headOfHospitalInventoryTableKeys}
          tableData={getHeadOfHospitalInventoryTableData(recent_orders)}
          tableTitle="Recent Transaction"
          loading={headOfHospitalInventoryStatLoading}
          spaced
          rowLineColor="light"
        />
      </div>
    </InventoryWrapper>
  );
};

export default PharmacyHeadInventory;
